import { useEffect, useState } from "react";
import { getAllJobs } from "../../../../API/recruitment/recruitmentService";
import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { RecruitmentData } from "../../../../components/tables/recruitment-tables/recruitment";

const breadcrumbItems = [
  { title: "Recrutement", link: "/admin-dashboard/recrutement" },
];
export default function Recruitment() {
  const [jobs, setJobs] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllJobs();
    setJobs(response?.jobs);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <RecruitmentData data={jobs} />
        </div>
      </div>
    </>
  );
}
